import { format, parseISO } from "date-fns";

const ENOUGH_SLOTS = 6;

/** Turns slot counts by day into the date picker's day states: `{ "2026-10-06": 7 }` → `{ "2026-10-06": "high" }`. */
export function dayStates(availability) {
  const states = {};
  for (const [day, slots] of Object.entries(availability ?? {})) {
    let state = "high";
    if (slots < 1) {
      state = "none";
    } else if (slots < ENOUGH_SLOTS) {
      state = "low";
    }
    states[format(parseISO(day), "yyyy-MM-dd")] = state;
  }
  return states;
}
